"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = firstDefined;
/**
 * Returns the first argument that is not undefined
 * @param {...*} values a list of arguments of any type
 * @returns {*}
 * @protected
 */
function firstDefined() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  for (var i = 0; i < values.length; i++) {
    if (values[i] !== undefined) return values[i];
  }
  return undefined;
}


//////////////////
// WEBPACK FOOTER
// ./~/cloudinary-react/lib/Util/firstDefined.js
// module id = 113
// module chunks = 156754375900144 213534597649335 231734337648933